import React, { useState, useEffect, useContext } from "react";
import { CircularProgress } from "@mui/material";
import { withStyles } from "@mui/styles";
import { withSnackbar } from "notistack";
import { Grid } from "@mui/material";
import { punctuationShowRoute } from "../../../network/api-routes";
import PunctuationForm from "./PunctuationForm";

import performRequest from "../../../network/perform-request";
import UserContext from "context/UserContext";
import { ROUTES } from "constants/routes";
import { useHistory } from "react-router-dom";

const styles = (theme) => ({
  container: {
    padding: `${theme.spacing(6)} ${theme.spacing(12)}`,
  },
  title: {
    fontWeight: 500,
    fontSize: 48,
  },
  subtitle: {
    fontWeight: 400,
    fontSize: 24,
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
});

const PunctuationSystemShow = (props) => {
  const [ready, setReady] = useState(false);
  const [punctuationSystem, SetPunctuationSystem] = useState(null);
  const { classes, match, enqueueSnackbar } = props;
  const { user, selectedOrganization } = useContext(UserContext);
  const history = useHistory();

  //on mount, check if we have a punctuation id in the url and fetch it
  useEffect(() => {
    console.log("match.params", match.params);
    if (match.params.uuid) {
      performRequest(
        "POST",
        punctuationShowRoute,
        { punctuation_system_uuid: match.params.uuid, organization_id: selectedOrganization?.id },
        user
      )
        .then((response) => {
          if (response.data) {
            console.log("punctuation system", response.data);
            SetPunctuationSystem(response.data);
            setReady(true);
          }
        })
        .catch((error) => {
          if (error.response?.status === 404) {
            enqueueSnackbar("Este sistema no pertenece a la organización seleccionada.", {
              variant: "error",
            });
            history.push(ROUTES.ADMIN.ORGANIZATIONS);
          } else {
            enqueueSnackbar(error.message, { variant: "error" });
          }
          setReady(true);
        });
    }
  }, [enqueueSnackbar, match.params, user]);

  if (!ready)
    return (
      <Grid container className={classes.container} justifyContent="center">
        <CircularProgress size={24} />
      </Grid>
    );

  return (
    <Grid container className={classes.container}>
      <Grid container item xs={12}>
        <Grid container item xs={12} lg={12} justifyContent="center">
          <PunctuationForm punctuationSystem={punctuationSystem} {...props} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(withSnackbar(PunctuationSystemShow));
